// action - state management
import { AUTHENTICATED, NOT_AUTHENTICATED, LOADING } from 'types';
import * as actionTypes from '../actions';

// ==============================|| AUTH REDUCER ||============================== //
export const initialState = {
    status: LOADING,
    user: {}
};

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOGIN:
            return {
                ...state,
                status: AUTHENTICATED,
                user: action.user
            };

        case actionTypes.LOGOUT:
            return {
                ...state,
                status: NOT_AUTHENTICATED,
                user: {}
            };

        default:
            return state;
    }
};

export default AuthReducer;
